module.exports = __webpack_public_path__ + "img/tswj.fd84967a.png";